"use client";
import { useTranslations } from "next-intl";
import AuthModalContainer from "./authModalContainer";
import HeadLine from "../headLine";
import LoginMainForm from "../loginMainForm";
import { useState } from "react";
import SendOtpForm from "../sendOtpForm";
import VerifySendOtpForm from "../verifyOtpForm";
import { cn } from "@/lib";
import { TFormMode } from "@/interfaces";
import ChangePasswordForm from "../changePasswordForm";
type TFormStep = "password" | "send-otp" | "verify-otp" | "change-password";

interface FormStepConfig {
  mode?: TFormMode;
  title: string;
  titleClass?: string;
  component: React.ReactNode;
}

type FormStepsConfig = Record<TFormStep, FormStepConfig>;

const LoginByPassModal = () => {
  const t = useTranslations("auth");
  const [formStep, setFormStep] = useState<TFormStep>("password");

  const formSteps: FormStepsConfig = {
    password: {
      mode: "password",
      title: t("headlines.loginHeadline"),
      component: <LoginMainForm nextFormStep={() => setFormStep("send-otp")} />,
    },
    "send-otp": {
      title: t("headlines.forgotPasswordHeadline"),
      component: (
        <SendOtpForm
          backFormStep={() => setFormStep("password")}
          nextFormStep={() => setFormStep("verify-otp")}
          fromForgotPass
          btnLabel={t("buttons.sendOtpSubmit")}
        />
      ),
    },
    "verify-otp": {
      mode: "otp",
      title: t("headlines.verifyOtpHeadline"),
      component: (
        <VerifySendOtpForm
          nextFormStep={() => setFormStep("change-password")}
          backFormStep={() => setFormStep("send-otp")}
          fromForgotPass
        />
      ),
    },
    "change-password": {
      title: t("headlines.changePasswordHeadline"),
      titleClass: "mb-8 w-full text-center text-sm",
      component: (
        <ChangePasswordForm backFormStep={() => setFormStep("send-otp")} />
      ),
    },
  };

  const current = formSteps[formStep];
  return (
    <AuthModalContainer formMode={current.mode}>
      {current.titleClass ? (
        <h2 className={cn(current.titleClass)}>{current.title}</h2>
      ) : (
        <HeadLine>{current.title}</HeadLine>
      )}
      {current.component}
    </AuthModalContainer>
  );
};

export default LoginByPassModal;
